export default __webpack_public_path__ + "static/media/gallery_00.455c66bf.jpg";